import React from 'react';
import './Terms.css';

const TermsIT = () => {
  return (
    <div className="terms-page">
      <h1>Termini e Condizioni</h1>
      <div className="terms-main">
        <p>
          Benvenuto su Rewards & Samples, LLC ("noi", "nostro" o "ci"). Accedendo e utilizzando 
          il nostro sito web, accetti i seguenti termini e condizioni.
        </p>

        <h3>1. CONDIZIONI D'USO</h3>
        <p>
          Questo sito web è gestito da Rewards & Samples, LLC. Utilizzando questo sito web, 
          accetti di essere vincolato da questi termini d'uso, tutte le leggi e regolamenti 
          applicabili.
        </p>

        <h3>2. IDONEITÀ</h3>
        <p>
          Per partecipare al nostro programma premi, devi:
        </p>
        <ul>
          <li>Avere almeno 18 anni</li>
          <li>Avere una residenza legale in Italia</li>
          <li>Fornire un indirizzo email valido</li>
          <li>Compilare tutte le informazioni di registrazione richieste in modo veritiero</li>
        </ul>

        <h3>3. PROGRAMMA PREMI</h3>
        <p>
          Il nostro programma premi ti consente di guadagnare ricompense completando offerte 
          sponsorizzate. Il numero di offerte richieste e il valore della ricompensa variano 
          a seconda del programma.
        </p>
        <ul>
          <li>Devi completare il numero richiesto di offerte sponsorizzate</li>
          <li>Le offerte devono essere completate entro il periodo di tempo specificato</li>
          <li>La verifica dell'identità è richiesta per ricevere i premi</li>
          <li>L'elaborazione dei premi può richiedere 5-7 giorni lavorativi</li>
        </ul>

        <h3>4. DISCLAIMER</h3>
        <p>
          I marchi e i nomi commerciali menzionati su questo sito web sono di proprietà dei 
          rispettivi proprietari e non sono affiliati con questa promozione. Non siamo 
          responsabili per prodotti o servizi di terze parti.
        </p>

        <h3>5. MODIFICHE AI TERMINI</h3>
        <p>
          Ci riserviamo il diritto di modificare questi termini in qualsiasi momento. Le 
          modifiche saranno pubblicate su questa pagina e entreranno in vigore immediatamente 
          dopo la pubblicazione.
        </p>

        <h3>6. PROPRIETÀ INTELLETTUALE</h3>
        <p>
          Tutti i contenuti di questo sito web, inclusi testo, grafica, loghi e software, 
          sono di proprietà di Rewards & Samples, LLC o dei suoi licenziatari e sono protetti 
          dalle leggi sul copyright.
        </p>

        <h3>7. LIMITAZIONE DI RESPONSABILITÀ</h3>
        <p>
          Non siamo responsabili per danni diretti, indiretti, incidentali, speciali o 
          consequenziali derivanti dall'uso o dall'impossibilità di utilizzare questo sito web.
        </p>

        <h3>8. LEGGE APPLICABILE</h3>
        <p>
          Questi termini sono regolati e interpretati in conformità con le leggi italiane. 
          Tutte le controversie saranno risolte presso i tribunali italiani.
        </p>

        <h3>9. CONTATTO</h3>
        <p>
          Se hai domande su questi termini, ti preghiamo di contattarci.
        </p>

        <div className="last-updated">
          Ultimo aggiornamento: Gennaio 2026
        </div>
      </div>
    </div>
  );
};

export default TermsIT;
